import header from "./real-estate-expert-presenting-office.jpg";
import section1 from "./close-up-architect-designing-plans.webp";
import section2 from "./architect-using-ruler-close-up.jpg";
import section3 from "./most-important-project-company.jpg";
import section4 from "./construction-equipment-repair.jpg";
import section5 from "./woman-working-with-geometric-triangle-pen.jpg";

export { header, section1, section2, section3, section4, section5 };
